import { render } from "./PublicidadMeta.vue?vue&type=template&id=208f0125&scoped=true"
import script from "./PublicidadMeta.vue?vue&type=script&lang=js"
export * from "./PublicidadMeta.vue?vue&type=script&lang=js"

import "./PublicidadMeta.vue?vue&type=style&index=0&id=208f0125&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208f0125"]])

export default __exports__